export default __webpack_public_path__ + "static/media/arrow-right-blue.27d28db8.svg";